<template>
    <div>
        <Button type="button" :id="button"  @mouseenter="hoverToggle" @click="toggle" @mouseleave="removeToggle"  aria-haspopup="true" aria-controls="overlay_tmenu" class="nav-hover-btn" >
          <div class="text-sm whitespace-nowrap flex items-center gap-1.5">
              {{ label.label }}
              <span
                v-if="label.badge"
                :title="`${label.badge} outreach draft(s) need attention (failed or overdue)`"
                class="inline-flex items-center justify-center min-w-[1.1rem] h-[1.1rem] px-1 rounded-full bg-red-500 text-white text-[10px] font-semibold leading-none"
              >{{ label.badge > 99 ? '99+' : label.badge }}</span>
          </div>
          <!-- <ChevronDownIcon
          class=" -mr-1 h-5 w-5 text-violet-200"
          aria-hidden="true"
          /> -->
        </Button>     
        <!-- <TieredMenu ref="menu" id="overlay_tmenu" :model="filteredLinks" popup /> -->
        <TieredMenu ref="menu" id="overlay_tmenu" :model="props.links" popup>
              <template #item="{ item, props, hasSubmenu, }">
                <a class="flex items-center justify-between h-8" v-bind="props.action">
                    <!-- <span :class="item.icon"></span> -->
                    <span class="whitespace-nowrap font-poppins">{{ item.label }}</span>
                    <span v-if="item.isNew || item.isBeta" class="flex space-x-1">
                      <span v-if="item.isNew" class="px-3 py-0.5 rounded-xl text-sm font-poppins bg-amber-200 text-amber-800">New</span>
                      <span v-if="item.isBeta" class="px-3 py-0.5 rounded-xl text-sm font-poppins bg-indigo-200 text-indigo-800">Beta</span>
                    </span>
                    <span v-if="hasSubmenu"><ChevronRightSVG /></span>
                    <!-- <Badge v-if="item.badge" class="ml-auto" :value="item.badge" />
                    <span v-if="item.shortcut" class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">{{ item.shortcut }}</span>
                    <i v-if="hasSubmenu" class="pi pi-angle-right ml-auto"></i> -->
                </a>
          </template>
        </TieredMenu>
    </div>
</template>

<script setup>
import { defineProps, ref, computed, defineEmits, watch } from 'vue';
import ChevronRightSVG from '../svg-components/ChevronRightSVG.vue';
import TieredMenu from 'primevue/tieredmenu';
import { Button } from 'primevue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const props = defineProps([
    'links',
    'label',
    'userPermissions',
])

const menu = ref(null)
const button = ref(`${props.label.label}Button`)
const store = useStore()
const shouldOpen = ref(false)
const router = useRouter()
const emit = defineEmits(['navigate-to-page'])


const toggle = (event) => {
  if(shouldOpen.value){
    menu.value.toggle(event);
  } else {
    if(props.label.defaultRoute){
      emit('navigate-to-page', props.label.defaultRoute, props.label.label)
    }
  }
};

const timeOutId = ref(null)

const hoverToggle = (event) => {
  timeOutId.value = setTimeout(() => {
    shouldOpen.value = true
    document.getElementById(button.value).click()
    shouldOpen.value = false
  }, 300)
}

function removeToggle(event){
  if(timeOutId.value){
    clearTimeout(timeOutId.value)
    timeOutId.value = null
    shouldOpen.value = false
  }
}


</script>

<style>
.nav-hover-btn {
    cursor: default !important;
}
.nav-hover-btn:hover {
    background: #4b5f7d !important;
    border-color: #4b5f7d !important;
    box-shadow: none !important;
}
</style>